<script>
  import MoleculeAvatarUserCard from "@/components/molecules/MoleculeAvatarUserCard.vue";
  import UserCheckArea from "@/components/cards/UserCheckArea.vue";
  export default {
    components: {
      MoleculeAvatarUserCard,
      UserCheckArea,
    },
    props: {
      users: {
        type: Array,
        default: () => [],
      },
      nameUser: {
        type: Function,
        required: true,
      },
      nameArea: {
        type: Function,
        required: true,
      },
      deleteUser: {
        type: Function,
        required: true,
      },
    },
  };
</script>

<template>
  <section class="userList">
    <div v-if="users.length" class="userList__usersAllowC custom__scroll">
      <div @click="deleteUser(user)" v-for="user in users" :key="user._id" class="userList__usersAllowContainer">
        <MoleculeAvatarUserCard :icon="user" :defaultText="nameUser(user)" />
        <UserCheckArea icon="close" :defaultText="nameArea(user)" />
      </div>
    </div>
  </section>
</template>

<style lang="scss">
  .userList {
    margin: 0.5rem 0;
    line-height: 17px;
    font-weight: 400;
    font-size: 14px;
    &__usersAllowContainer {
      @include Flex(row, space-between);
      margin: 8px 0;
      padding: 8px 11px;
      background: rgba(250, 250, 250, 1);
      border-radius: 10px;
    }
    &__usersAllowC {
      height: 250px;
      overflow-y: auto;
    }
  }

  .custom__scroll::-webkit-scrollbar {
    width: 17px;
  }

  .custom__scroll::-webkit-scrollbar-thumb {
    background-color: #979797;
    border-radius: 20px;
    border: 6px solid transparent;
    background-clip: content-box;
  }
</style>
